import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import useLocalStorage from 'use-local-storage'
import { productionWork, trackPageView } from '../API/axios'
import Footer from './Navigation/Footer'
import Header from './Navigation/Header'
import LeftNavigation from './Navigation/LeftNavigation'
import RightNavigation from './Navigation/RightNavigation'
import useWindowSize from './useWindowSize';
import GuestModeFooter from './GuestModeFooter'
import CreateCompany from './CreateCompany/CreateCompany'
import useChatStore from './OuterChatBox/useChatStore'
import ChatBox from './OuterChatBox/OuterChatBox';
import "./OuterChatBox/OuterChatbox.css";
import useNewsFeedStore from './NewsFeed/useNewsFeedStore'
import { useNotificationCount } from '../hooks/useNotificationCount'
import { useMessageCount } from '../hooks/useMessageCount'
import { requireRealtimeAuth } from '../utils/jwtUtils'
import { startRealtimeHub } from '../Services/realtimeHubService'

const RootLayout = () => {
    const { chats } = useChatStore();
    const { isNewsPageLoaded } = useNewsFeedStore();
    const location = useLocation();

    useEffect(() => {
        trackPageView(location.pathname + location.search + location.hash);
    }, [location.pathname, location.search, location.hash]);

    const shouldHideChatbox = location.pathname.startsWith("/Message");

    const [isDark, setIsDark] = useLocalStorage('isDark', false)
    useEffect(() => {
        document.body.style.backgroundColor = isDark ? '#1a1a1e' : '#F2F2F2';
    }, [isDark]);

    useEffect(() => {
        const sessionId = localStorage.getItem("sessionId");
        if (!sessionId) return;

        if (!requireRealtimeAuth()) return;

        startRealtimeHub().catch(() => {
            // best-effort hub bootstrap for authenticated layout
        });
    }, []);
    const [showModal, setShowModal] = useState(false);


    const openModal = () => {
        setShowModal(true)
        // console.log("Menu is toggling...");
    };


    const closeModal = () => {
        setShowModal(false);
    };
    const size = useWindowSize();
    const isMobile = size.width <= 768;
    const guestModeData = localStorage.getItem("guestMode");
    // console.log('guestModeData', guestModeData);

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen((prevState) => !prevState);
        // console.log("Menu is toggling...");
    };

    const { notifiCount, setNotifiCount, NotificationCount } = useNotificationCount();
    const { msgCount, setMsgCount, MessagesCount } = useMessageCount();

    return (
        <div className='app'>
            <Header
                isDark={isDark}
                setIsDark={setIsDark}
                notifiCount={notifiCount}
                setNotifiCount={setNotifiCount}
                NotificationCount={NotificationCount}
                msgCount={msgCount}
                setMsgCount={setMsgCount}
                MessagesCount={MessagesCount}
            />
            <div className="container-fluid ps-lg-0">
                {isMobile ? (
                    <>
                        <div className="row rootLayout mobileView main-LaptopMobile px-lg-0 px-0">
                            <div
                                className={`col-md-12 laptop-mobileview ${location.pathname.startsWith("/People") ||
                                        location.pathname.startsWith("/Companies") ||
                                        location.pathname.startsWith("/User")
                                        ? "px-0"
                                        : "px-md-2"
                                    }`}
                            >
                                {/* <div onClick={openModal}>asdsadasdasd</div> */}
                                <Outlet />
                            </div>
                        </div>
                        <Footer />
                    </>
                ) : (
                    <div className="row rootLayout desktopView">

                        <div className="col-md-3 left pe-0">
                            <LeftNavigation isOpen={isOpen} toggleMenu={toggleMenu} setIsOpen={setIsOpen}

                                openModal={openModal} />
                        </div>
                        <div className="col-md-6 center ps-0 pe-0 postfeed-center">
                            <Outlet />
                        </div>
                        <div className="col-md-3 right ps-3 pe-0">
                            {isNewsPageLoaded && <RightNavigation />}
                        </div>
                    </div>
                )}
            </div>

            {guestModeData === 'true' ? <GuestModeFooter /> : ''}
            {/* {console.warn("===========1=========>>", showModal)} */}
            {showModal && (
                <CreateCompany
                    openModal={openModal}
                    showModal={showModal}
                    closeModal={closeModal}
                    getCompanyList={''}
                />
            )}
            {console.log("chats...........", chats)
            }
            {
                chats && !shouldHideChatbox && (
                    <div data-theme={isDark ? "dark" : "light"} className="chat-container">
                        {chats.map(user => (
                            <ChatBox key={user.userUid} user={user} />
                        ))}
                    </div>
                )
            }
        </div>
    )
}

export default RootLayout